import {Action} from '@ngrx/store';
import { BenefitName } from 'libs/benefits/src/lib/models/benefit.model';
import { AnamneseFunctionALUploadType, AnamneseUploadType } from 'libs/media/src/lib/models/media.model';
import { ProductKey, ProductOptions } from 'libs/product/src/lib/models/product.model';
import { SapShippingCostItem } from 'libs/sap/src/lib/models/sap.model';
import { TreatmentModel } from 'libs/treatments/src/lib/models/treatment.model';

export enum AnamneseActionTypes {
	JawToggled = '[Anamnese] Jaw Toggled',
	BothJawsUpdated = '[Anamnese] Both Jaws Updated',
	ToothAreaUpdated = '[ToothAreaUpdatedAction] Tootharea Updated',
	PatientSelected = '[Anamnese] Patient Selected',
	ProductSelected = '[Anamnese] Product Selected',
	OptionsUpdated = '[Anamnese] Options Updated',
	QuestionaireUpdated = '[Anamnese] Questionaire Updated',
	QuestionaireAnswersUpdated = '[Anamnese] Questionaire Answers Updated',
	QuestionairePreparedAnswersUpdated = '[Anamnese] Questionaire Prepared Answers Updated',
	ClearAnamneseRequested = '[Anamnese] Clear Anamnese',
	ClearAnamneseUploadedFilesRequested ="[Anamnese] Clear Anamnese Uploaded Media Files",
	ClearQuestionaireRequested = '[Anamnese] Questionaire Clear',
	SettingsUpdated = '[Anamnese] Settings Updated',
	HandlingUpdated = '[Anamnese] Handling Updated',
	TreatmentIdUpdated = '[Anamnese] Treatment ID updated',
	MediaFileUploaded ="[Anamnese] Uploaded mediafile",
	MediaFileDeleted ="[Anamnese] Deleted mediafile",
	MediaFileFunctionALUploaded ="[Anamnese] Uploaded functionAL mediafile",
	MediaFileFunctionALDeleted ="[Anamnese] Deleted functionAL mediafile",
	ParentTreatmentSelected = "[Anamnese] Parent Treatment Selected",
	CaseAssessmentTreatmentSelected = "[Anamnese] Case Assessment Treatment Selected",
	ShippingCostsLoaded = '[Anamnese] Shipping Costs Loaded',
	SetDiscountedMemotainQuota = '[Anamnese] Set Discounted Memotain Quota',
	ProfessionalPrintServiceSelected = '[Anamnese] Professional Print Service Selected',
	SetSkipDataTransferFlag = '[Anamnese] Set Skip Data Transfer Flag',
	SetAvailableBenefits = '[Anamnese] Set Available Benefits',
	SetSelectedBenefitName = '[Anamnese] Set Selected Benefit Name'
}


export class ClearAnamneseAction implements Action {
	readonly type = AnamneseActionTypes.ClearAnamneseRequested;
}

export class ClearAnamneseUploadedFilesAction implements Action {
	readonly type = AnamneseActionTypes.ClearAnamneseUploadedFilesRequested;
}

export class ToothAreaUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.ToothAreaUpdated;
	constructor( public payload) {}
}
export class JawToggledAction implements Action {
	readonly type = AnamneseActionTypes.JawToggled;
	constructor( public payload) {}
}

export class BothJawsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.BothJawsUpdated;
	constructor() {}
}
export class PatientSelectedAction implements Action {
	readonly type = AnamneseActionTypes.PatientSelected;
	constructor( public payload) {}
}

export class ProductSelectedAction implements Action {
	readonly type = AnamneseActionTypes.ProductSelected;
	constructor(public payload: { key: ProductKey, options?: ProductOptions }) { }
}
export class OptionsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.OptionsUpdated;
	constructor( public payload) {}
}
export class SetSkipDataTransferFlagAction implements Action {
	readonly type = AnamneseActionTypes.SetSkipDataTransferFlag;
	constructor( public payload: boolean ) {}
}
export class QuestionairePreparedAnswersUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.QuestionairePreparedAnswersUpdated;
	constructor( public payload) {}
}
export class QuestionaireAnswersUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.QuestionaireAnswersUpdated;
	constructor( public data, public productKey: ProductKey ) {}
}
export class HandlingUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.HandlingUpdated;
	constructor( public payload) {}
}
export class SettingsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.SettingsUpdated;
	constructor( public payload) {}
}

export class MediaFileUploadedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileUploaded;
	constructor( public uploadType: AnamneseUploadType, public mediaId: string, public orgFilename: string, public index: number = 0 ) {}
}
export class MediaFileDeletedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileDeleted;
	constructor( public uploadType: AnamneseUploadType, public index: number = 0 ) {}
}
export class MediaFileFunctionALUploadedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileFunctionALUploaded;
	constructor( public uploadType: AnamneseFunctionALUploadType, public mediaId: string, public orgFilename: string) {}
}
export class MediaFileFunctionALDeletedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileFunctionALDeleted;
	constructor( public uploadType: AnamneseFunctionALUploadType ) {}
}
export class TreatmentIdUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.TreatmentIdUpdated;
	constructor( public payload) {}
}
export class ShippingCostsLoaded implements Action {
	readonly type = AnamneseActionTypes.ShippingCostsLoaded;
	constructor( public payload: {shippingCosts: SapShippingCostItem[]}) {}
}

export class ParentTreatmentSelectedAction implements Action {
	readonly type = AnamneseActionTypes.ParentTreatmentSelected;
	constructor(public payload: { parentTreatmentId: string }) { }
}

export class CaseAssessmentTreatmentSelectedAction implements Action {
	readonly type = AnamneseActionTypes.CaseAssessmentTreatmentSelected;
	constructor(public payload: { caseAssessmentTreatment: TreatmentModel }) { }
}

export class SetDiscountedMemotainQuotaAction implements Action {
	readonly type = AnamneseActionTypes.SetDiscountedMemotainQuota;
	constructor(public payload: { ujAvailable: boolean, ljAvailable: boolean }) { }
}

export class ProfessionalPrintServiceSelectedAction implements Action {
	readonly type = AnamneseActionTypes.ProfessionalPrintServiceSelected;
	constructor(public isSelected: boolean) { }
}

export class SetAvailableBenefitsAction implements Action {
	readonly type = AnamneseActionTypes.SetAvailableBenefits;
	constructor(public benefits: BenefitName[] ) { }
}

export class SetSelectedBenefitNameAction implements Action {
	readonly type = AnamneseActionTypes.SetSelectedBenefitName;
	constructor(public benefitName: BenefitName) { }
}

export type AnamneseActions =
	| ClearAnamneseAction
	| ClearAnamneseUploadedFilesAction
	| ToothAreaUpdatedAction
	| JawToggledAction
	| BothJawsUpdatedAction
	| PatientSelectedAction
	| ProductSelectedAction
    | OptionsUpdatedAction
	| QuestionairePreparedAnswersUpdatedAction
	| QuestionaireAnswersUpdatedAction
	| HandlingUpdatedAction
	| SettingsUpdatedAction
	| MediaFileUploadedAction
	| MediaFileDeletedAction
	| MediaFileFunctionALUploadedAction
	| MediaFileFunctionALDeletedAction
	| ParentTreatmentSelectedAction
	| CaseAssessmentTreatmentSelectedAction
	| TreatmentIdUpdatedAction
	| ShippingCostsLoaded
	| SetDiscountedMemotainQuotaAction
	| ProfessionalPrintServiceSelectedAction
	| SetSkipDataTransferFlagAction
	| SetAvailableBenefitsAction
	| SetSelectedBenefitNameAction;

